define('app/views/templates/helpers/checkRequiredPhoneType',['Handlebars','underscore'], function ( Handlebars, _ ){
    function checkRequiredPhoneType(phoneType) {
        var phoneTypes = Customization.requirePhoneTypes;
        return _.some(phoneTypes, function(type){
            return type.toLowerCase() === phoneType.toLowerCase();
            });     
    }

    Handlebars.registerHelper( 'checkRequiredPhoneType', checkRequiredPhoneType );
    return checkRequiredPhoneType;
});
